import { createAction } from '@reduxjs/toolkit'

export const fetchProducts = createAction('insights/fetchProducts')
export const updateProduct = createAction('insights/updateProduct')
export const createProduct = createAction('insights/createProduct')
export const deleteProduct = createAction('insights/deleteProduct')
